<template>
  <div class="emb-aboutus-wrap">
    <emb-page-title
      :image="bannerSection.Banner_Image_1920x700_px"
      :heading="bannerSection.Title"
      :subHeading="bannerSection.Subtitle"
    ></emb-page-title>
    <div class="emb-about-content">
      <div class="about-page section-gap">
        <v-container grid-list-xl>
          <v-layout row wrap align-center>
            <v-flex xs12 sm12 md12 lg6 xl6 pr-5>
              <h2 class="font-weight-bold font-italic mb-6">{{contentAreaSection.Content1}}</h2>
              <h4 class="font-weight-bold mb-6">{{contentAreaSection.Content2}}</h4>
              <div class="mb-6" v-html="contentAreaSection.Content2"></div>
              <!-- <p class="mb-6" v-html="contentAreaSection.Content2"></p> -->
              <!-- <v-btn large class="accent mx-0">{{contentAreaSection.Button_Label}}</v-btn> -->
            </v-flex>
            <v-flex xs12 md12 lg6 xl6 text-lg-left text-center>
              <img
                alt="About us Figure"
                :src="contentAreaSection.About_Image_540x540_px"
                width="700"
                height="700"
              />
            </v-flex>
          </v-layout>
        </v-container>
      </div>
      <div class="about-info section-gap bg-grey">
        <v-container grid-list-xl py-0>
          <v-layout row wrap align-center mb-md-0 mb-6>
            <v-flex xl6 sm12 xs12 md6 lg6 text-md-left text-center>
              <img :src="ourMissionSection.Image_540x420_px" alt="mission" width="900" height="700" />
            </v-flex>
            <v-flex xl6 xs12 md6 lg6 class="pl-12">
              <h2 class="font-weight-bold">{{ourMissionSection.Title}}</h2>
              <h5 class="font-italic">{{ourMissionSection.Content1}}</h5>
              <!-- <p v-html="ourMissionSection.Content2"></p> -->
              <div v-html="ourMissionSection.Content2"></div>
            </v-flex>
          </v-layout>
          <v-layout row wrap align-center reverse>
            <v-flex xl6 xs12 md6 lg6>
              <img :src="ourVisionSection.Image_540x420_px" alt="vission" width="900" height="700" />
            </v-flex>
            <v-flex xl6 xs12 md6 lg6 class="pr-12">
              <h2 class="font-bold">{{ourVisionSection.Title}}</h2>
              <h5 class="font-italic">{{ourVisionSection.Content1}}</h5>
              <!-- <p v-html="ourVisionSection.Content2"></p> -->
              <div v-html="ourVisionSection.Content2"></div>
            </v-flex>
          </v-layout>
        </v-container>
      </div>
      <TestimonialV2 :testimonial="testimonialSection" />
      <div class="team-section text-center section-gap blue-grey lighten-5">
        <v-container grid-list-xl text-xl-center>
          <div class="sec-title">
            <h2>{{teamSection.Crew_Title}}</h2>
          </div>
          <v-layout row wrap align-center justify-center>
            <v-flex
              xs12
              sm12
              md4
              lg4
              xl4
              text-center
              mb-sm-0
              mb-3
              v-for="(teamMembers,key) in teamSection.Crew_List"
              :key="key"
            >
              <div class="team-card mb-6">
                <img
                  class="br-100"
                  :src="teamMembers.Image_200x200_px"
                  width="200"
                  height="200"
                  alt="team-image"
                />
              </div>
              <div class="team-content">
                <h4 class="mb-0">{{teamMembers.Name}}</h4>
                <p class="mb-6">{{teamMembers.Position}}</p>
                <!-- <p class="mb-6" v-html="teamMembers.Description"></p> -->
                <div class="mb-6" v-html="teamMembers.Description"></div>
              </div>
            </v-flex>
          </v-layout>
        </v-container>
      </div>
      <div class="about-contact-form">
        <v-layout row wrap>
          <v-flex xs12 sm12 md6 lg6 xl6 class="about-contact-bg" :style="'background-image: url('+ bgImage +')'"></v-flex>
          <v-flex xs12 sm12 md6 lg6 xl6 section-gap>
            <div class="about-contact-form-inner">
              <div>
                <h2 class="mb-3">{{feedbackSection.Form_Title}}</h2>
              </div>
              <v-form ref="form" v-model="valid">
                <v-text-field
                  type="text"
                  v-model="firstName"
                  :placeholder="feedbackSection.Firstname_Placeholder"
                ></v-text-field>
                <v-text-field
                  type="text"
                  v-model="lastName"
                  :placeholder="feedbackSection.Lastname_Placeholder"
                ></v-text-field>
                <v-text-field
                  type="email"
                  v-model="email"
                  :placeholder="feedbackSection.Email_Placeholder"
                ></v-text-field>
                <v-text-field
                  type="text"
                  v-model="subject"
                  :placeholder="feedbackSection.Subject_Placeholder"
                ></v-text-field>
                <v-textarea rows="2" v-model="message" :label="feedbackSection.Message_Placeholder"></v-textarea>
                <v-btn
                  class="accent mx-0"
                  large
                  @click.stop.prevent="saveDetails"
                >{{feedbackSection.Button_Label}}</v-btn>
              </v-form>
            </div>
          </v-flex>
        </v-layout>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import TestimonialV2 from "Components/Widgets/TestimonialV2";
import gettingRestClientObject from "../../services/utils/cms-helper";
import VueMoment from "vue-moment";
import moment from "moment-timezone";

Vue.use(VueMoment, {
  moment,
});
export default {
  computed: {
    ...mapGetters(["rtlLayout", "selectedLocale"]),
  },
  components: {
    TestimonialV2,
  },
  data() {
    return {
      bgImage: "",
      cmsRequestFunctions: null,
      bannerSection: "",
      contentAreaSection: "",
      ourMissionSection: "",
      ourVisionSection: "",
      testimonialSection: "",
      teamSection: "",
      feedbackSection: "",

      firstName: "",
      lastName: "",
      email: "",
      subject: "",
      message: "",

      valid: false,
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+/.test(v) || "E-mail must be valid",
      ],
      inputRules: {
        basictextRules: [(v) => !!v || "This field should not be empty"],
      },
      /**
       * Slick Options
       **/
      slickOptions: {
        autoplay: false,
        slidesToShow: 1,
        infinite: false,
        arrows: false,
        dots: false,
        slidesToScroll: 1,
        swipe: true,
        seed: 100,
        rtl: this.rtlLayout,

        responsive: [
          {
            breakpoint: 390,
          },
        ],
      },
      /**
       *** Data
       **/

      teamListing: null,
    };
  },
  mounted() {
    this.cmsRequestFunctions = gettingRestClientObject();
    this.getPageData();
  },
  watch: {
    selectedLocale: function () {
      this.getPageData();
    },
  },
  methods: {
    saveDetails: async function () {
      //   this.$refs.form.validate();

      if (!this.firstName) {
        this.$snotify.warning(
          this.cmsRequestFunctions.getValidationMsgByCode("M005"),
          {
            closeOnClick: false,
            pauseOnHover: false,
            timeout: 1000,
            showProgressBar: false,
          }
        );
        return false;
      }
      if (!this.email) {
      this.$snotify.warning(
          this.cmsRequestFunctions.getValidationMsgByCode("M007"),
          {
            closeOnClick: false,
            pauseOnHover: false,
            timeout: 1000,
            showProgressBar: false,
          }
        );
        return false;
      }
      var emailPat = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
      var matchArray = this.email.match(emailPat);
      if (matchArray == null) {
       this.$snotify.warning(
          this.cmsRequestFunctions.getValidationMsgByCode("M010"),
          {
            closeOnClick: false,
            pauseOnHover: false,
            timeout: 1000,
            showProgressBar: false,
          }
        );
        return false;
      }
      if (!this.subject) {
        this.$snotify.warning(
          this.cmsRequestFunctions.getValidationMsgByCode("M012"),
          {
            closeOnClick: false,
            pauseOnHover: false,
            timeout: 1000,
            showProgressBar: false,
          }
        );
        return false;
      }
      if (!this.message) {
        this.$snotify.warning(
          this.cmsRequestFunctions.getValidationMsgByCode("M013"),
          {
            closeOnClick: false,
            pauseOnHover: false,
            timeout: 1000,
            showProgressBar: false,
          }
        );
        return false;
      } else {
        let requestedDate = moment(String(new Date())).format(
          "YYYY-MM-DDThh:mm:ss"
        );
        var sendingRequest = {
          type: "User Enquiries",
          keyword1: this.firstName,
          keyword2: this.lastName,
          keyword3: this.email,
          text1: this.subject,
          text2: this.message,
          date1: requestedDate,
        };
        let responseObject = await this.cmsRequestFunctions.cmsFormData(
          sendingRequest
        );
        try {
          let insertID = Number(responseObject);
          console.log(insertID);
          //   var emailApi = ServiceUrls.emailServices.emailApi;
          //   sendMailService(emailApi, postData);
          //   sendMailService(emailApi, custmail);
          this.firstName = "";
          this.lastName = "";
          this.email = "";
          this.subject = "";
          this.message = "",
            this.$snotify.success(
          this.cmsRequestFunctions.getValidationMsgByCode("M038"),
          {
            closeOnClick: false,
            pauseOnHover: false,
            timeout: 1000,
            showProgressBar: false,
          }
        );
        } catch (e) {
          console.log(e);
        }
      }
    },
    getPageData: function () {
      var self = this;
      var language = localStorage.Language ? localStorage.Language : "en";

      var config = {
        pageType: "Template/",
        pageUrl: "04 About Us/04 About Us/04 About Us.ftl",
        lang: language,

        successCallback: function (response) {
          // console.log(response);
          var res = response.data;
          if (res.area_List) {
            var bannerArea = self.cmsRequestFunctions.pluck(
              "Banner_Section",
              res.area_List
            );
            self.bannerSection = self.cmsRequestFunctions.getAllMapData(
              bannerArea[0].component
            );
            var aboutContentArea = self.cmsRequestFunctions.pluck(
              "About_Content_Area",
              res.area_List
            );
            self.contentAreaSection = self.cmsRequestFunctions.getAllMapData(
              aboutContentArea[0].component
            );
            var ourMissionArea = self.cmsRequestFunctions.pluck(
              "Our_Mission_Section",
              res.area_List
            );
            self.ourMissionSection = self.cmsRequestFunctions.getAllMapData(
              ourMissionArea[0].component
            );
            var ourVisionArea = self.cmsRequestFunctions.pluck(
              "Our_Vision_Section",
              res.area_List
            );
            self.ourVisionSection = self.cmsRequestFunctions.getAllMapData(
              ourVisionArea[0].component
            );
            var testinomialArea = self.cmsRequestFunctions.pluck(
              "Testimonial_Section",
              res.area_List
            );
            self.testimonialSection = self.cmsRequestFunctions.getAllMapData(
              testinomialArea[0].component
            );
            var teamArea = self.cmsRequestFunctions.pluck(
              "Team_Section",
              res.area_List
            );
            self.teamSection = self.cmsRequestFunctions.getAllMapData(
              teamArea[0].component
            );
            var feedbackArea = self.cmsRequestFunctions.pluck(
              "Feedback_Section",
              res.area_List
            );
            self.feedbackSection = self.cmsRequestFunctions.getAllMapData(
              feedbackArea[0].component
            );
            self.bgImage = self.feedbackSection.Image_700x700__px;
          }
        },
        errorCallback: function (error) {
          console.log(error);
        },
      };
      this.cmsRequestFunctions.cmsRequest(config, language);
    },
  },
};
</script>
